export default __webpack_public_path__ + "static/media/pexels-anna-nekrashevich-8534221.924a984c.jpg";